module.exports = __webpack_public_path__ + "static/media/litnet-min.4d4e701d.png";